import React from 'react';
import {Table} from 'antd';
import SystemButtonHub from './SystemButtonHub';
import SystemButtonAccount from './SystemButtonAccount';

class SystemTable extends React.Component {
  handleSetSystem = (system) => {
    const {onSetSystem} = this.props
    onSetSystem(system)
  }

  render() {
    const {role, systems, fetching} = this.props
    const columns = [
      {
        title: 'Tên',
        dataIndex: 'Name',
        key: 'name'
      }, {
        title: '...',
        key: 'action',
        render: (text, system) => (<span><SystemButtonHub system={system} onSetSystem={this.handleSetSystem}/>
          <span className="ant-divider"/><SystemButtonAccount system={system} onSetSystem={this.handleSetSystem}/></span>)
      }
    ];
    return <Table columns={columns} dataSource={systems} rowKey={sys => sys.ID} loading={fetching}/>
  }
}
export default SystemTable



// WEBPACK FOOTER //
// ./src/components/SystemTable.js